import { ActionCreator } from "../types/store-types";
import {
    AuthActionTypes,
    InitUserRequestActionType,
    InitUserSuccessActionType,
    InitUserFailureActionType,
    SetUserTokenActionType,
    SetLoadingActionType,
    ClearErrorsActionType,
    MigrateGuestToUserRequestActionType,
    MigrateGuestToUserSuccessActionType,
    MigrateGuestToUserFailureActionType,
    GetCurrentUserRequestActionType,
    GetCurrentUserSuccessActionType,
    GetCurrentUserFailureActionType,
    GetZapierAuthURLRequestActionType,
    GetZapierAuthURLSuccessActionType,
    GetZapierAuthURLFailureActionType,
    DisconnectIntegrationRequestActionType,
    DisconnectIntegrationSuccessActionType,
    DisconnectIntegrationFailureActionType,
    GetHubspotAuthURLRequestActionType,
    GetHubspotAuthURLSuccessActionType,
    GetHubspotAuthURLFailureActionType,
    GetHubspotDataRequestActionType,
    GetHubspotDataSuccessActionType,
    GetHubspotDataFailureActionType,
    GetHubspotStatusRequestActionType,
    GetHubspotStatusSuccessActionType,
    GetHubspotStatusFailureActionType,
    UpdateHubspotPropertyFailureActionType,
    UpdateHubspotPropertySuccessActionType,
    UpdateHubspotPropertyRequestActionType,
    GetHubspotTablesRequestActionType,
    GetHubspotTablesSuccessActionType,
    GetHubspotTablesFailureActionType,
    InitHubspotRequestActionType,
    InitHubspotSuccessActionType,
    InitHubspotFailureActionType,
} from "./types";

/* -- Init User Request Action -- */

export const initUserRequest: ActionCreator<InitUserRequestActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_REQUEST,
    payload,
});

export const initUserSuccess: ActionCreator<InitUserSuccessActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_SUCCESS,
    payload,
});

export const initUserFailure: ActionCreator<InitUserFailureActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_FAILURE,
    payload,
});

export const getCurrentUserRequest: ActionCreator<GetCurrentUserRequestActionType> = payload => ({
    type: AuthActionTypes.GET_CURRENT_USER_REQUEST,
    payload,
});

export const getCurrentUserSuccess: ActionCreator<GetCurrentUserSuccessActionType> = payload => ({
    type: AuthActionTypes.GET_CURRENT_USER_SUCCESS,
    payload,
});

export const getCurrentUserFailure: ActionCreator<GetCurrentUserFailureActionType> = payload => ({
    type: AuthActionTypes.GET_CURRENT_USER_FAILURE,
    payload,
});

export const setUserToken: ActionCreator<SetUserTokenActionType> = payload => ({
    type: AuthActionTypes.SET_USER_TOKEN,
    payload,
});

export const setAuthLoading: ActionCreator<SetLoadingActionType> = payload => ({
    type: AuthActionTypes.SET_LOADING,
    payload,
});

export const clearAuthErrors: ActionCreator<ClearErrorsActionType> = payload => ({
    type: AuthActionTypes.CLEAR_ERRORS,
    payload,
});

export const migrateUserRequest: ActionCreator<MigrateGuestToUserRequestActionType> = payload => ({
    type: AuthActionTypes.MIGRATE_GUEST_TO_USER_REQUEST,
    payload,
});

export const migrateUserSuccess: ActionCreator<MigrateGuestToUserSuccessActionType> = payload => ({
    type: AuthActionTypes.MIGRATE_GUEST_TO_USER_SUCCESS,
    payload,
});

export const migrateUserFailure: ActionCreator<MigrateGuestToUserFailureActionType> = payload => ({
    type: AuthActionTypes.MIGRATE_GUEST_TO_USER_FAILURE,
    payload,
});

export const getZapierAuthURLRequest: ActionCreator<GetZapierAuthURLRequestActionType> = payload => ({
    type: AuthActionTypes.GET_ZAPIER_AUTH_URL_REQUEST,
    payload,
});

export const getZapierAuthURLSuccess: ActionCreator<GetZapierAuthURLSuccessActionType> = payload => ({
    type: AuthActionTypes.GET_ZAPIER_AUTH_URL_SUCCESS,
    payload,
});

export const getZapierAuthURLFailure: ActionCreator<GetZapierAuthURLFailureActionType> = payload => ({
    type: AuthActionTypes.GET_ZAPIER_AUTH_URL_FAILURE,
    payload,
});

export const disconnectIntegrationRequest: ActionCreator<DisconnectIntegrationRequestActionType> = payload => ({
    type: AuthActionTypes.DISCONNECT_INTEGRATION_REQUEST,
    payload,
});

export const disconnectIntegrationSuccess: ActionCreator<DisconnectIntegrationSuccessActionType> = payload => ({
    type: AuthActionTypes.DISCONNECT_INTEGRATION_SUCCESS,
    payload,
});

export const disconnectIntegrationFailure: ActionCreator<DisconnectIntegrationFailureActionType> = payload => ({
    type: AuthActionTypes.DISCONNECT_INTEGRATION_FAILURE,
    payload,
});

export const getHubspotAuthURLRequest: ActionCreator<GetHubspotAuthURLRequestActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_AUTH_URL_REQUEST,
    payload,
});
export const getHubspotAuthURLSuccess: ActionCreator<GetHubspotAuthURLSuccessActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_AUTH_URL_SUCCESS,
    payload,
});

export const getHubspotAuthURLFailure: ActionCreator<GetHubspotAuthURLFailureActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_AUTH_URL_FAILURE,
    payload,
});

export const getHubspotDataRequest: ActionCreator<GetHubspotDataRequestActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_DATA_REQUEST,
    payload,
});
export const getHubspotDataSuccess: ActionCreator<GetHubspotDataSuccessActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_DATA_SUCCESS,
    payload,
});

export const getHubspotDataFailure: ActionCreator<GetHubspotDataFailureActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_DATA_FAILURE,
    payload,
});

export const getHubspotStatusRequest: ActionCreator<GetHubspotStatusRequestActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_STATUS_REQUEST,
    payload,
});
export const getHubspotStatusSuccess: ActionCreator<GetHubspotStatusSuccessActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_STATUS_SUCCESS,
    payload,
});

export const getHubspotStatusFailure: ActionCreator<GetHubspotStatusFailureActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_STATUS_FAILURE,
    payload,
});

export const updateHubspotPropertyRequest: ActionCreator<UpdateHubspotPropertyRequestActionType> = payload => ({
    type: AuthActionTypes.UPDATE_HUBSPOT_PROPERTY_REQUEST,
    payload,
});
export const updateHubspotPropertySuccess: ActionCreator<UpdateHubspotPropertySuccessActionType> = payload => ({
    type: AuthActionTypes.UPDATE_HUBSPOT_PROPERTY_SUCCESS,
    payload,
});

export const updateHubspotPropertyFailure: ActionCreator<UpdateHubspotPropertyFailureActionType> = payload => ({
    type: AuthActionTypes.UPDATE_HUBSPOT_PROPERTY_FAILURE,
    payload,
});
export const getHubspotTablesRequest: ActionCreator<GetHubspotTablesRequestActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_TABLES_REQUEST,
    payload,
});
export const getHubspotTablesSuccess: ActionCreator<GetHubspotTablesSuccessActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_TABLES_SUCCESS,
    payload,
});

export const getHubspotTablesFailure: ActionCreator<GetHubspotTablesFailureActionType> = payload => ({
    type: AuthActionTypes.GET_HUBSPOT_TABLES_FAILURE,
    payload,
});

export const initHubspotRequest: ActionCreator<InitHubspotRequestActionType> = payload => ({
    type: AuthActionTypes.INIT_HUBSPOT_REQUEST,
    payload,
});
export const initHubspotSuccess: ActionCreator<InitHubspotSuccessActionType> = payload => ({
    type: AuthActionTypes.INIT_HUBSPOT_SUCCESS,
    payload,
});

export const initHubspotFailure: ActionCreator<InitHubspotFailureActionType> = payload => ({
    type: AuthActionTypes.INIT_HUBSPOT_FAILURE,
    payload,
});
